import React from 'react'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

// components
import {
  CSmartTable,
  CButton,
  CImage,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CSmartPagination,
  CBadge,
  CFormInput
} from '@coreui/react-pro'

// icons
import ThreeDotsIconMenu from '../assets/icons/ThreeDotsOptionsIcon.png'

// styling
import { styleButtonVars3, styleButtonVars5 } from './custom-styles/buttonStyles'

const AppTable = ({
  contactListPage,
  setShowConfirmDelete,
  setShowConfirmEdit,
  selectable,
  handleOnRowClick,
  isClickable = false,
  tableColumns,
  tableContent,
  contentPerPage,
  activeContentPage,
  contentCount,
  setActiveContentPage,
  tableFilter,
  searchContentFilter,
  setSearchContentFilter,
  setContentPerPage,
  columnContentSorter,
  setColumnContentSorter,
  isShowModalEdit,
  isLoading,
  isShowPagination = true,
  isShowDropdownMenu = true,
  isShowButtonCopy = false,
  handleCopyToClipboard,
  isShowButtonDelete = true,
  isShowTextProcessing = false,
  isShowColumnFilter = false,
}) => {
  const navigate = useNavigate()

  return (
    <>
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3 gap-3">
        <div>
          <span className="me-2">Search:</span>
          <CFormInput
            placeholder="Search..."
            value={searchContentFilter}
            onChange={(e) => setSearchContentFilter(e?.target.value)}
            style={{ display: 'inline-block', width: '250px' }}
          />
        </div>
        {
          isShowTextProcessing && (
            <div>
              <CBadge color="warning">Processing...</CBadge>
            </div>
          )
        }
      </div>
      <CSmartTable
        columns={tableColumns}
        columnFilter={ isShowColumnFilter ? { external: true } : false}
        columnSorter={{ multiple: true, resetable: true, external: true }}
        sorterValue={columnContentSorter}
        items={tableContent}
        itemsPerPage={contentPerPage}
        itemsPerPageSelect={isShowPagination}
        onItemsPerPageChange={(itemsPerPage) => setContentPerPage(itemsPerPage)}
        tableProps={{
          className: 'app-table-content-list',
          hover: true,
          responsive: true,
          style: {
            cursor: 'pointer'
          }
        }}
        tableHeadProps={{
          className: 'app-table-header'
        }}
        pagination={isShowPagination}
        loading={isLoading}
        selectable={selectable}
        clickableRows={isClickable}
        onRowClick={(item, _, columnName) => handleOnRowClick(item, columnName)}
        onSorterChange={(value) => setColumnContentSorter(value)}
        scopedColumns={{
          date: (item) => (
            <td>
              {moment(item?.date).format('DD/MM/YYYY')}
            </td>
          ),
          register_date: (item) => (
            <td>
              {moment(item?.register_date).format('DD/MM/YYYY')}
            </td>
          ),
          start_date: (item) => (
            <td>
              {moment(item?.start_date).format('DD/MM/YYYY')}
            </td>
          ),
          end_date: (item) => (
            <td>
              {moment(item?.end_date).format('DD/MM/YYYY')}
            </td>
          ),
          createdAt: (item) => (
            <td>
              {moment(item?.createdAt).format('DD/MM/YYYY')}
            </td>
          ),
          attachment_url: (item) => (
            <td>
              {
                item?.attachment_url ? (
                  <a href={item?.attachment_url} target='_blank' media='file'>
                    View
                  </a>
                )
                : (
                  <>
                    No attachment
                  </>
                )
              }
            </td>
          ),
          file_url: (item) => (
            <td>
              {
                item?.file_url ? (
                  <CButton
                    style={styleButtonVars5}
                    href={item?.file_url}
                    target='_blank'
                  >
                    View document
                  </CButton>
                )
                : (
                  <>
                    No attachment
                  </>
                )
              }
            </td>
          ),
          copy: (item) => (
            <td>
              {
                isShowButtonCopy && (
                  <CButton
                    style={styleButtonVars3}
                    onClick={() => {
                      handleCopyToClipboard(item?.letter_number)
                    }}
                  >
                    Copy
                  </CButton>
                )
              }
            </td>
          ),
          action: (item, index) => (
            <td>
              <CDropdown>
                {
                  isShowDropdownMenu && (
                    <>
                      <CDropdownToggle
                        color="white"
                        caret={false}
                        style={{
                          border: "none",
                          boxShadow: "none",
                          background: "#FFF",
                          borderBottomRightRadius: ".3rem",
                          borderTopRightRadius: ".3rem",
                        }}
                        split
                      >
                        <CImage fluid src={ThreeDotsIconMenu} />
                      </CDropdownToggle>
                      <CDropdownMenu>
                        <CDropdownItem
                          onClick={() => {
                            if (isShowModalEdit) {
                              setShowConfirmEdit({ show: true, item, index })
                            } else {
                              let urlEdit = contactListPage ? `/contacts/edit/${item.id}`
                              : null

                              navigate(urlEdit)
                            }
                          }}
                        >
                          Edit {
                            contactListPage ? 'Contact'
                              : ''
                          }
                        </CDropdownItem>
                        {
                          isShowButtonDelete && (
                            <CDropdownItem
                              onClick={() => setShowConfirmDelete({ show: true, type: contactListPage ? 'contacts' : '' , item: item, index })}
                            >
                              Delete {
                                contactListPage ? 'Contact'
                                  : ''
                              }
                            </CDropdownItem>
                          )
                        }
                      </CDropdownMenu>
                    </>
                  )
                }
              </CDropdown>
            </td>
          )
        }}
      />
      {
        isShowPagination && (
          <CSmartPagination
            align="center"
            activePage={activeContentPage}
            pages={Math.ceil(contentCount / contentPerPage) || 1}
            onActivePageChange={(activePage) => setActiveContentPage(activePage)}
            p
          />
        )
      }
    </div>
    </>
  )
}

export default AppTable
